import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56407795"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__exam-sheet" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "sheet" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["name", "value"]

import { computed, ref } from "vue";
  import { useStore } from "vuex";
  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin"
  import BackButton from "vue/applications/frontend/components/back-button.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'exam-sheet',
  setup(__props) {

  const form = ref<HTMLFormElement | null>(null);
  // Guards against a double-clicked "Speichern" firing form.submit() twice before
  // the page navigates away, which created duplicate Bögen (and doubled the
  // documented Mengen entries).
  const isSubmitting = ref<boolean>(false);

  const store = useStore();
  const content = computed(() => store.state.gon.content);

  // request methods other than GET or POST are not supported by all browsers and therefore simulated via a POST request
  // returns the request method which is actually used by the browser (i.e. GET or POST)
  const actualRequestMethod = computed(() => {
    if (!content.value.form_options) return undefined;
    if ([ 'get', 'post' ].includes(content.value.form_options?.method)) return content.value.form_options?.method;
    return 'post';
  });

  // returns whether the desired request method is simulated by a POST request
  // if it is the case, a hidden _method input field is generated as part of the form
  const isOtherRequestMethodSimulated = computed(() => {
    return actualRequestMethod != (content.value.form_options || {}).method;
  });

  const submit = () => {
    if (content.value.as_form) {
      if (isSubmitting.value) return;
      // previously, form.value.requestSubmit() was used
      // however, unfortunately it is not supported on Safari < 16
      if(form.value && form.value.reportValidity()) {
        isSubmitting.value = true;
        form.value.submit();
      }
    } else {
      console.error("Not rendered as a form. This should not happen.");
    }
  };

  const submitAsDraft = () => {
    // mark exam as draft, then submit normally
    if (form.value) {
      form.value['exam[is_draft]'].value = true;
      submit();
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (content.value && content.value.title)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["g--broad_heading print--no-shadow print--black-and-white", [_unref(themingCssClass)('inverted')]])
            }, [
              _createTextVNode(_toDisplayString(content.value.title) + " ", 1),
              _createVNode(BackButton)
            ], 2))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent(content.value.as_form ? 'form' : 'div'), {
          ref_key: "form",
          ref: form,
          action: (content.value.form_options || {}).action,
          method: actualRequestMethod.value
        }, {
          default: _withCtx(() => [
            (isOtherRequestMethodSimulated.value)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  name: "_method",
                  type: "hidden",
                  value: content.value.form_options?.method
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (content.value.as_form)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(content.value.form_options?.data, (value, name) => {
                  return (_openBlock(), _createElementBlock("input", {
                    key: name,
                    type: "hidden",
                    name: name,
                    value: value
                  }, null, 8, _hoisted_5))
                }), 128))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value.cards, (card) => {
              return (_openBlock(), _createElementBlock("div", {
                key: card.key,
                class: _normalizeClass(["card print--no-shadow print--no-padding", {'print--hide': card.print_hide}])
              }, [
                (card.title)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["title", [_unref(themingCssClass)('normal')]])
                    }, _toDisplayString(card.title), 3))
                  : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_resolveDynamicComponent(card.component), {
                  description: card,
                  onSubmit: submit,
                  onSubmitAsDraft: submitAsDraft
                }, null, 40, ["description"]))
              ], 2))
            }), 128))
          ]),
          _: 1
        }, 8, ["action", "method"]))
      ])
    ])
  ]))
}
}

})